import styles from './index.module.scss';
import blueLoading from '@/assets/img/blueLoading.png';
export function LoadStatus() {

    return <div className={styles.loading}>
        <img src={blueLoading} className={styles.imgSty} />
    </div>;
}
export function ErrorStatus({onRetry}: {onRetry: () => void}) {

    return <div className={styles.loading}>
        <div className={styles.retry}>
            <span
                className={styles.leftText}
            >加载失败 </span>
            <span
                className={styles.rightText}
                onClick={onRetry}
            >点击重试</span>
        </div>
    </div>;
}
